import { Component, OnInit, OnDestroy, ViewChild, Injector } from '@angular/core';
import { LazyLoaderService } from '../services/lazy-loader.service';
import { HelpService } from '../services/help.service';
import { HelpResult } from '../models/help';
import { AppConstants } from '../app_setting/app-constants';
import * as firebase from 'firebase';

declare const startQismo: any;
declare var $: any;

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    $('.qismo-extra').hide();
    $('.qcw-container').hide();
  }

  search: string = '';
  data: HelpResult = new HelpResult();
  isOnSearch: boolean = false;
  isLoading: boolean = false;
  isEmpty: boolean = false;

  constructor(
    private helpService: HelpService) { }

  ngOnInit() {
    firebase.analytics().logEvent('bantuan_page');

    this.loadHelp(null, null);
    this.loadScript();
  }

  loadScript(): void {
    $(document).ready(function () {
      if ($('div.qismo-extra').length > 0) {
        $('.qismo-extra').show();
        $('.qcw-container').show();
      } else {
        var profile = localStorage.getItem(AppConstants.ProfileStorageId);
        startQismo(profile);
      }
    });
  }

  loadHelp(event: Event, name: string) {
    this.isEmpty = false;
    this.isLoading = true;
    this.helpService.getListHelp(this.search,
      resp => {
        this.isLoading = false;
        if (resp.alert.code == 200) {
          if (this.search != '' && resp.data.faqs.length == 0) {
            this.isEmpty = true;
          }
          this.data = resp.data;

          if (this.search === '') {
            this.data.types.forEach(item => {
              const faq = this.data.faqs.find(type => type.type === item.e);
              if (faq) {
                item.note = 'exist';
              } else {
                item.note = 'empty';
              }
            });
          }
        }

        this.isOnSearch = this.search != '' ? true : false;
        if (event != null && name != null)
          setTimeout(() => openTabsJs(name), 100);
      },
      err => {
        this.isLoading = false;
      });
  }

  openTab(name: string) {
    if (this.search != '') {
      this.search = '';
      this.isOnSearch = false;
      this.loadHelp(event, name)
    } else
      openTabsJs(name);
  }

}

function openTabsJs(name) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(name).style.display = "block";
  document.getElementById('btn' + name).className += " active";
}
